import { IMicrofrontendsAPI } from 'shared/types/microfrontends/types';

import { openAuthModal } from '../../repositories/header-frontend/v3/open-auth-modal/helpers';

import { getDesktopFiltersMicrofrontendApi } from './getDesktopFiltersMicrofrontendApi';
import { getSearchStringMicrofrontendAPI } from './getSearchStringMicrofrontendApi';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    getSearchStringMicrofrontendAPI,
    getDesktopFiltersMicrofrontendApi,
    header: {
      openAuthModal,
    },
  };
}
